import { IProduct, TDiscountStyle } from 'mod/product/interface';

export const handleYesClick = () => {
}

import { COOKIE_COUNTRY, DEBUG_AGE_GATE } from 'base/config/constant';
import { COOKIE_AGE_GATE, QUERY_AGE_VERIFIED } from 'mod/age-gate/constant';
import { RouteEnum } from 'pro/config/routers';
import { generatePath } from 'ava-util/dist/request';

/**
 * 检查是否需要跳转年龄检查
 * @param serverAgeLimit    页面接口返回（ageLimit） 是否需要
 * @param query             url参数(age_verified、debug_age)
 * @param cookies           cookie 等等数据
 */
export const checkAgeGate = (
    serverAgeLimit,
    query,
    cookies,
) => {
    return !!(
        (serverAgeLimit || query[DEBUG_AGE_GATE] || query[QUERY_AGE_VERIFIED])
        && !cookies[`${COOKIE_AGE_GATE}_${cookies[COOKIE_COUNTRY]}`]
    );

}

export const getAgeGatePath = (redirectUrl) => {
    return generatePath(RouteEnum.AGE_GATE, { redirect: redirectUrl })
}

export const goAgeGatePage = (resolvedUrl) => {
    return {
        redirect: {
            destination: getAgeGatePath(resolvedUrl),
            permanent: false
        }
    };
}